import React from 'react';
import { Text } from '../../../../../atoms/Text/Text';
import { STOP_STATUS_TEXT_KEY } from '../../constants';
import { dayBriefCardText, splitTimeSpan } from '../../helpers';
import { DayBriefStopDetails } from '../DayBriefStopDetails';
import { DayBriefVisitRow } from '../DayBriefVisitRow';
import './DayBriefStopCardStyles.scss';
const baseClass = 'qmb-ui-DayBriefStopCard';
/** One stop: the time span, the site, its visits, then access, contacts and notes. */
export function DayBriefStopCard({ stop }) {
    const { building } = stop;
    const { start, end } = splitTimeSpan(stop.time_span);
    // A status the server adds later has no key: it renders unlabelled rather than throwing.
    const statusKey = STOP_STATUS_TEXT_KEY[stop.status];
    return (React.createElement("section", { className: baseClass, "aria-label": building.name },
        React.createElement(Text, { variant: "x-small", className: `${baseClass}__span` },
            React.createElement("span", { className: `${baseClass}__span-line` }, start),
            end && React.createElement("span", { className: `${baseClass}__span-line` },
                "\u2013 ",
                end)),
        React.createElement("div", { className: `${baseClass}__card` },
            React.createElement("div", { className: `${baseClass}__status-row` },
                React.createElement("span", { className: `${baseClass}__dot ${baseClass}__dot--${stop.status}`, "aria-hidden": "true" }),
                statusKey && (React.createElement(Text, { variant: "x-small", className: `${baseClass}__status` }, dayBriefCardText(statusKey))),
                React.createElement(Text, { variant: "xx-small", className: `${baseClass}__label` }, stop.label)),
            React.createElement("div", { className: `${baseClass}__rail` },
                React.createElement("div", { className: `${baseClass}__site` },
                    React.createElement(Text, { variant: "small", as: "h4", className: `${baseClass}__name` }, building.name),
                    building.address && React.createElement(Text, { variant: "body" }, building.address)),
                React.createElement("ul", { className: `${baseClass}__visits` }, stop.visits.map((visit, index) => (React.createElement(DayBriefVisitRow
                // eslint-disable-next-line react/no-array-index-key
                , { 
                    // eslint-disable-next-line react/no-array-index-key
                    key: `${index}-${visit.reference}`, visit: visit, buildingName: building.name, directionsUrl: building.directions_url })))),
                React.createElement(DayBriefStopDetails, { access: stop.access, contacts: stop.contacts, siteNotes: stop.site_notes })))));
}
